const COUNTRY_LABELS = {
  UAE: "United Arab Emirates",
};

export function formatCountryName(country = "") {
  const value = String(country).trim();
  return COUNTRY_LABELS[value] || value;
}

/** Format order shippingAddress for display */
export function getShippingDisplayLines(shippingAddress = {}) {  if (!shippingAddress || typeof shippingAddress !== "object") return [];

  const lines = [];

  if (shippingAddress.fullName) {
    lines.push({ label: "Full name", value: shippingAddress.fullName });
  }
  if (shippingAddress.email) {
    lines.push({ label: "Email", value: shippingAddress.email });
  }
  if (shippingAddress.phone) {
    lines.push({ label: "Phone", value: shippingAddress.phone });
  }
  if (shippingAddress.companyName) {
    lines.push({ label: "Company", value: shippingAddress.companyName });
  }

  const street = [shippingAddress.line1, shippingAddress.line2]
    .filter(Boolean)
    .join(", ");
  if (street) {
    lines.push({ label: "Delivery address", value: street });
  }

  const locality = [shippingAddress.city, shippingAddress.emirate]
    .filter(Boolean)
    .join(", ");
  if (locality) {
    lines.push({ label: "City / Emirate", value: locality });
  }

  if (shippingAddress.country) {
    lines.push({
      label: "Country",
      value: formatCountryName(shippingAddress.country),
    });
  }

  return lines;
}

export function hasShippingDetails(shippingAddress = {}) {
  return getShippingDisplayLines(shippingAddress).length > 0;
}
